<template>
  <div>
    <a-data-table
      :headers="headers"
      :items="items"
      item-key="value"
      dense
      :no-data-text="$t('noData')"
      :no-results-text="$t('emptySearchRecords')"
      :disable-sort="true"
      :hide-default-footer="true"
      :items-per-page="50"
    >
      <template v-slot:[`item.emailSubject`]="{ item }">
        <div class="subject-text-box">{{ item.subject }}</div>
      </template>
      <template v-slot:[`item.#`]="{ item }">
        <v-radio-group
          v-model="selectedId"
          row
          dense
          @change="onTemplateChange"
        >
          <v-radio :value="item.id"></v-radio>
        </v-radio-group>
      </template>
      <template v-slot:item.action="{ item }">
        <action-template
          :defaultTemplate="item.default"
          @edit="onEdit(item)"
          @delete="onDelete(item.id)"
          @copy="copyTemplate(item)"
        ></action-template>
      </template>
    </a-data-table>
    <confirm-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ActionTemplate from "../settings/ActionTemplate.vue";
import ConfirmDialog from "../ConfirmDialog.vue";
export default {
  components: { ActionTemplate, ConfirmDialog },
  name: "TemplateTable",
  props: {
    setting: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: () => [],
    },
  },
  data() {
    return {
      selectedId: null,
    };
  },
  watch: {
    items(values) {
      const activeItem = values.find((item) => item.active);
      if (activeItem) {
        this.selectedId = activeItem.id;
      }
    },
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    emailTemplates() {
      const templates = this.tenantSettingConfig("email_templates");
      return templates.email_templates;
    },
    headers() {
      let { columns } = this.setting;
      return columns.map((obj) => {
        return {
          ...obj,
          text: this.$t(`admin.${obj.text}`),
          class: "header header-text",
        };
      });
    },
  },
  methods: {
    onEdit,
    onDelete,
    onTemplateChange,
    copyTemplate
  },
};
async function copyTemplate(item) {
  if (
    await this.$refs.confirm.open(
            this.$t("lblConfirm"),
            this.$t("template.hCopyMessage")
          )
  ) {
   
   this.$emit("copy", item);
  }
}
async function onTemplateChange(value) {
  const item = this.items.find((item) => item.id === value);
  if (!item) return;

  if (item.default) {
    const activeItem = this.items.find((item) => item.active && !item.default);
    if (activeItem) activeItem.active = false;
    this.$emit("onTemplateChange", activeItem || null);
  } else {
    item.active = true;
    this.$emit("onTemplateChange", item);
  }
}

function onEdit(item) {
  this.$emit("edit", item);
}

function onDelete(id) {
  // const item = values.find((item) => item.id) === id;
  this.$emit("delete", id);
}
</script>

<style>
.subject-text-box {
  max-width: 700px;      /* limit width */
  word-wrap: break-word; /* break long words */
  overflow-wrap: break-word; /* modern replacement */
  white-space: normal;   /* allow wrapping */
}
</style>